import { Backpack, Map, ClipboardList, Crown } from 'lucide-react';
import ListImage from '../../../../../assets/ListImage.png';
import Suitcase from '../../../../../assets/Suitcase.png';
import Worldwide from '../../../../../assets/Worldwide.png';
import Report from '../../../../../assets/Report.png';
import Crown1 from '../../../../../assets/Crown.png';
export const statsData = [
    { title: "Total Packing Lists", value: "540", icon: ListImage, bgColor: "bg-bgprimary", isFirst: true },
    { title: "Active Packing Lists", value: "540", icon: Suitcase, bgColor: "bg-white" },
    { title: "Destinations Covered", value: "540", icon: Worldwide, bgColor: "bg-white" },
    { title: "Regular Packing Lists", value: "540", icon: Report, bgColor: "bg-white" },
    { title: "PRO Packing Lists", value: "540", icon: Crown1, bgColor: "bg-white" },
];

export const tableData = [
    {
        id: 1,
        name: "Nicholas",
        type: "Pro",
        destination: ["USA", "Europe"],
        climate: "Cold",
        duration: "7 days",
        bodyType: "Female",
        packingStyle: "Minimal",
        tags: ["Adventure", "Hiking"],
    },
];

export const genderData = [
    { name: 'Male', value: 70 },
    { name: 'Female', value: 30 },
];

export const activityData = [
    { name: 'Urban', value: 30 },
    { name: 'Nature', value: 45 },
    { name: 'Beach', value: 60 },
    { name: 'Mountain', value: 75 },
    { name: 'Outdoor', value: 90 },
];

export const destinationData = [
    { name: 'USA', value: 100 },
    { name: 'France', value: 50 },
    { name: 'Italy', value: 75 },
    { name: 'Japan', value: 45 },
    { name: 'Canada', value: 30 },
];